export class ApiError extends Error {
    status;
    code;
    details;
    requestId;
    constructor(args) {
        super(args.message);
        this.name = "ApiError";
        this.status = args.status;
        this.code = args.code;
        this.details = args.details;
        this.requestId = args.requestId;
    }
    isUnauthorized() {
        return this.status === 401;
    }
    isForbidden() {
        return this.status === 403;
    }
    isNotFound() {
        return this.status === 404;
    }
    isConflict() {
        return this.status === 409;
    }
    isValidationError() {
        return this.status === 400 && this.code === "VALIDATION_FAILED";
    }
    /** Validation エラーの details（フィールド別エラー）を取り出す */
    getFieldErrors() {
        if (!this.isValidationError() || !this.details)
            return null;
        if (typeof this.details !== "object")
            return null;
        return this.details;
    }
}
export function isApiError(err) {
    return err instanceof ApiError;
}
/** apps/api が返すエラーレスポンスを ApiError に正規化する */
export async function parseApiError(res) {
    let body = null;
    try {
        body = (await res.json());
    }
    catch {
        body = null;
    }
    return new ApiError({
        status: res.status,
        code: body?.error?.code ?? `HTTP_${res.status}`,
        message: body?.error?.message ?? `API エラー (${res.status})`,
        details: body?.error?.details,
        requestId: body?.requestId,
    });
}
